import { Pipe, PipeTransform } from '@angular/core';

const FROM = 7;
const TO = 12;

@Pipe({
  name: 'maskCardNumber',
  standalone: true,
})
export class MaskCardNumberPipe implements PipeTransform {
  transform(value: string): string {
    return [...value].map(this.#correctSymbol.bind(this)).join('');
  }

  #correctSymbol(symbol: string, i: number): string {
    return this.#inRange(i + 1, FROM, TO) ? '*' : symbol;
  }

  #inRange(value: number, min: number, max: number): boolean {
    return value <= max && value >= min;
  }
}
